import { useEffect, useState } from "react";
import { CommonService } from "../../../../services/CommonService";
import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";
import { DropDownMultiCheck } from "../DropDownMultiCheck";
import IconDelete from "../../../../layout/others/icon-x.svg";

export default function SeniorityLevel({ searchObject, setSearchObject, t }) {
  const [seniorityLevels, setSeniorityLevels] = useState([]);

  useEffect(
    () =>
      CommonService.getAllSeniorityLevels().then((data) =>
        setSeniorityLevels(data)
      ),
    []
  );

  function setSelectedSeniorityLevelOptions(list) {
    setSearchObject({ ...searchObject, seniorityLevels: list });
  }

  function clearSeniorityLevel() {
    let _searchObject = { ...searchObject };
    _searchObject.seniorityLevels = [];

    setSearchObject(_searchObject);
  }

  return (
    <div>
      <legend className="fontsize-legend">{t("Seniority Level")}</legend>
      {searchObject.seniorityLevels?.length !== 0 && (
        <button
          onClick={clearSeniorityLevel}
          className="btn-clear-language-level btn-mobile position-clear-button"
        >
          <img src={IconDelete} alt="ico-ppl" height="12px" width="auto" />
        </button>
      )}
      <DropDownMultiCheck
        dataList={seniorityLevels}
        selecteds={searchObject.seniorityLevels}
        setSelecteds={setSelectedSeniorityLevelOptions}
      />
    </div>
  );
}
